import { z } from "zod";

import { ThemeMode } from "../theme/theme.ts";
import { ThemeSource } from "../theme/themeRef.ts";

import { ScreenType } from "./supportedScreens.ts";

export const ScreenDesignSpecification = z.object({
  screenType: ScreenType,
  /**
   * What this screen wears. Written on every screen generation creates and
   * every screen v16 migrates, so it answers for itself and a change to the
   * file's default cannot repaint it.
   *
   * Optional only for a screen that has never stated one — pasted in, parsed
   * from JSX, or hand-drawn — which falls through to its file.
   */
  themeSource: ThemeSource.optional(),
  /**
   * Stored apart from the source so a dark screen does not read as a theme
   * override, and optional on the same terms.
   */
  themeMode: ThemeMode.optional(),
  fragments: z
    .array(z.object({ purpose: z.string(), markup: z.string() }))
    .optional(),
});

export type ScreenDesignSpecification = z.infer<
  typeof ScreenDesignSpecification
>;
